import { render, staticRenderFns } from "./blankTo.vue?vue&type=template&id=c5908aca&scoped=true&"
import script from "./blankTo.vue?vue&type=script&lang=js&"
export * from "./blankTo.vue?vue&type=script&lang=js&"
import style0 from "./blankTo.vue?vue&type=style&index=0&id=c5908aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5908aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5908aca')) {
      api.createRecord('c5908aca', component.options)
    } else {
      api.reload('c5908aca', component.options)
    }
    module.hot.accept("./blankTo.vue?vue&type=template&id=c5908aca&scoped=true&", function () {
      api.rerender('c5908aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blankTo.vue"
export default component.exports